<div class="d-flex justify-content-end m-3">
  <ng-container *ngIf="this.transactionService.itemToEdit.AssignedToCurrentUser">
    <button class="save mr-3" (click)="tryUpdateFormData('update-pdf-form')">
      <span *ngIf="!isSaving()">{{ 'save' | translate }}</span>
      <div *ngIf="isSaving() && saving.action=='update-pdf-form'" class="d-flex justify-content-center align-items-center">
        <mat-spinner [diameter]="20" class="mat-spinner-color"></mat-spinner>
      </div>
    </button>
  </ng-container>

  <button class="print mr-3" (click)="openPdfInNewTab()">
    <mat-icon>print</mat-icon>
    {{ 'print' | translate }}
  </button>

  <button class="close" (click)="close()">
    {{ 'close' | translate }}
  </button>
</div>

<ng-container *ngIf="mainService.fileToLoad && isPDF == false">
  <ngx-extended-pdf-viewer
  [showPrintButton]="false"
    [src]="mainService.fileToLoad"
    height="100%"
    width="100%"
    [formData]="mainService.formData"
    (formDataChange)="onFormChange($event)">
  </ngx-extended-pdf-viewer>
</ng-container>

<ng-container *ngIf="mainService.fileToLoad && isPDF == true">
  <iframe frameborder="0" height="100%" width="100%" [src]="mainService.fileToLoad | safe"></iframe>
</ng-container>
